import type { NavigationGuard } from 'vue-router'
import { routeNames } from '@/router/names.ts'
import { useAccountStore } from '@/stores/account.ts'

export const validateSubAccountIdGuard: NavigationGuard = async (to, from, next) => {
    const subAccountIdFromRoute = to.params.subAccountId ? String(to.params.subAccountId) : null

    if (!subAccountIdFromRoute) {
        return next({
            name: routeNames.LOGIN_VIEW_NAME,
        })
    }

    const accountStore = useAccountStore()

    if (!accountStore.accountData) {
        return next({
            name: routeNames.LOGIN_VIEW_NAME,
        })
    }

    if (!accountStore.accountData.assignSubaccounts.includes(subAccountIdFromRoute)) {
        return next({
            name: routeNames.LOGIN_VIEW_NAME,
        })
    }

    return next()
}
